/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useContext } from 'react';
import { UserContext } from '../../../contexts/User';
import PlanSelector from '../../../components/PlanSelector';

function Plans() {
  const { activeWorkspace } = useContext(UserContext);
  return (
    <PlanSelector activeWorkspace={activeWorkspace} context="settings" />
  );
}

export default Plans;
